(function () {
  var COMPONENT_EVENTS = [
    ["pointerdown", { passive: true }],
    ["pointerup", { passive: true }],
    ["pointermove", { passive: true }],
    ["mouseenter", false],
    ["mouseleave", false],
    ["touchstart", { passive: true }],
    ["touchend", { passive: true }],
    ["touchmove", { passive: true }],
    ["mousedown", { passive: true }],
    ["mouseup", { passive: true }],
    ["mousemove", { passive: true }],
    ["wheel", { passive: true }],
    ["click", false],
    ["keydown", false],
    ["focusin", false],
  ];

  var SLIDER_EVENTS = [
    ["scroll", { passive: true }],
    ["wheel", { passive: true }],
    ["pointermove", { passive: true }],
    ["pointerup", { passive: true }],
    ["touchmove", { passive: true }],
    ["touchend", { passive: true }],
    ["mousemove", { passive: true }],
  ];

  function waitForComponent(component, callback) {
    if (
      typeof component.play === "function" &&
      typeof component.pause === "function"
    ) {
      callback();
      return;
    }

    if (
      window.customElements &&
      typeof window.customElements.whenDefined === "function"
    ) {
      window.customElements
        .whenDefined("slideshow-component")
        .then(callback)
        .catch(function () {
          window.requestAnimationFrame(callback);
        });
      return;
    }

    var attempts = 0;
    (function retry() {
      attempts += 1;
      if (
        typeof component.play === "function" &&
        typeof component.pause === "function"
      ) {
        callback();
        return;
      }
      if (attempts < 10) {
        window.requestAnimationFrame(retry);
      }
    })();
  }

  function shouldTriggerFromKey(event) {
    if (event.type !== "keydown") {
      return true;
    }

    var actionableKeys = ["Enter", " ", "Spacebar", "ArrowLeft", "ArrowRight"];
    return actionableKeys.indexOf(event.key) !== -1;
  }

  function pauseInitialAutoplay(component, allowFallback) {
    if (component.dataset.autoplayDeferredState === "paused") {
      return true;
    }

    if (!component.sliderAutoplayButton) {
      if (allowFallback) {
        if (typeof component.pause === "function") {
          component.pause();
        }
        component.dataset.autoplayDeferredState = "paused";
        return true;
      }
      return false;
    }

    if (typeof component.autoplayButtonIsSetToPlay === "undefined") {
      if (allowFallback) {
        if (typeof component.pause === "function") {
          component.pause();
        }
        component.dataset.autoplayDeferredState = "paused";
        return true;
      }
      return false;
    }

    if (typeof component.pause === "function") {
      component.pause();
    }

    if (
      component.sliderAutoplayButton &&
      typeof component.autoplayButtonIsSetToPlay !== "undefined"
    ) {
      if (component.autoplayButtonIsSetToPlay) {
        component.sliderAutoplayButton.click();
      }
    }

    component.dataset.autoplayDeferredState = "paused";
    return true;
  }

  function resumeAutoplay(component) {
    if (component.dataset.autoplayDeferredResumed === "true") {
      return;
    }

    component.dataset.autoplayDeferredResumed = "true";

    if (
      component.sliderAutoplayButton &&
      typeof component.autoplayButtonIsSetToPlay !== "undefined"
    ) {
      if (!component.autoplayButtonIsSetToPlay) {
        component.sliderAutoplayButton.click();
        return;
      }
    }

    if (typeof component.play === "function") {
      component.play();
    }
  }

  function bindDeferredResume(component, slider) {
    if (component.dataset.autoplayDeferredBound === "true") {
      return;
    }

    component.dataset.autoplayDeferredBound = "true";

    var listeners = [];

    function removeListeners() {
      listeners.forEach(function (entry) {
        var target = entry[0];
        var eventName = entry[1];
        var handler = entry[2];
        var options = entry[3];
        target.removeEventListener(eventName, handler, options || false);
      });
      listeners = [];
    }

    var interactionHandler = function (event) {
      if (!shouldTriggerFromKey(event)) {
        return;
      }

      resumeAutoplay(component);
      removeListeners();
    };

    var addListener = function (target, eventName, options) {
      target.addEventListener(eventName, interactionHandler, options || false);
      listeners.push([target, eventName, interactionHandler, options]);
    };

    COMPONENT_EVENTS.forEach(function (entry) {
      addListener(component, entry[0], entry[1]);
    });

    if (slider) {
      SLIDER_EVENTS.forEach(function (entry) {
        addListener(slider, entry[0], entry[1]);
      });
    }

    component.addEventListener("slideChanged", function handler() {
      resumeAutoplay(component);
      component.removeEventListener("slideChanged", handler);
      removeListeners();
    });
  }

  function initialiseComponent(component) {
    if (component.dataset.autoplayDeferredInitialised === "true") {
      return;
    }

    var slider = component.querySelector('[data-autoplay-deferred="true"]');
    if (!slider || slider.dataset.autoplay !== "true") {
      return;
    }

    waitForComponent(component, function () {
      var attempts = 0;
      var maxAttempts = 40;

      (function ensurePaused() {
        attempts += 1;
        if (pauseInitialAutoplay(component, attempts >= maxAttempts)) {
          bindDeferredResume(component, slider);
          component.dataset.autoplayDeferredInitialised = "true";
        } else if (attempts < maxAttempts) {
          window.requestAnimationFrame(ensurePaused);
        }
      })();
    });
  }

  function initialise(context) {
    (context || document)
      .querySelectorAll("slideshow-component")
      .forEach(function (component) {
        initialiseComponent(component);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initialise(document);
    });
  } else {
    initialise(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initialise(event.target || document);
  });
})();

